import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

const GET_CAT_API_BASE_URL = "https://mediapi.onlinepharmaque.in/api/v1";

const Order = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ================= FETCH ORDERS =================
  const fetchOrders = async () => {
    try {
      const res = await fetch(`${GET_CAT_API_BASE_URL}/getorders`);
      const data = await res.json();
      setOrders(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
      setOrders([]);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // ================= STATUS UPDATE =================
  const updateStatus = async (orderId, status) => {
    try {
      await fetch(`${GET_CAT_API_BASE_URL}/status/${orderId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      });

      fetchOrders(); // refresh
    } catch (error) {
      console.log(error);
    }
  };

  const statusColor = (status) => {
    switch (status) {
      case "Placed":
        return "text-yellow-400";
      case "Processed":
        return "text-blue-400";
      case "Shipped":
        return "text-purple-400";
      case "Delivered":
        return "text-green-400";
      case "Canceled":
        return "text-red-400";
      default:
        return "text-white";
    }
  };

  return (
    <div className="p-6 text-white">
      {/* ===== Header ===== */}
      <div className="bg-[#1F2A40] rounded-xl px-6 py-5 mb-6">
        <h2 className="text-xl font-semibold">Order Management</h2>
        <p className="text-sm text-green-400">
          Track & manage customer orders
        </p>
      </div>

      {/* ===== Table ===== */}
      <div className="bg-[#1F2A40] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#3E4396]">
            <tr>
              <th className="px-5 py-3 text-left">#</th>
              <th className="px-5 py-3 text-left">City</th>
              <th className="px-5 py-3 text-left">Pincode</th>
              <th className="px-5 py-3 text-left">Amount</th>
              <th className="px-5 py-3 text-left">Status</th>
              <th className="px-5 py-3 text-left">Date</th>
            </tr>
          </thead>

          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-400">
                  No Orders found
                </td>
              </tr>
            ) : (
              orders.map((order, i) => (
                <tr
                  key={order._id}
                  className="border-b border-gray-700 hover:bg-[#2A344D]"
                >
                  {/* Number */}
                  <td className="px-5 py-3">{i + 1}</td>

                  {/* City */}
                  <td className="px-5 py-3">
                    {order.address?.city || "-"}
                  </td>

                  {/* Pincode */}
                  <td className="px-5 py-3">
                    {order.address?.pincode || "-"}
                  </td>

                  {/* Amount */}
                  <td className="px-5 py-3 text-emerald-400 font-semibold">
                    ₹ {order.grandTotal}
                  </td>

                  {/* Status */}
                  <td className="px-5 py-3">
                    <select
                      value={order.status}
                      onChange={(e) =>
                        updateStatus(order._id, e.target.value)
                      }
                      className={`bg-transparent border border-gray-600 rounded px-2 py-1 ${statusColor(
                        order.status
                      )}`}
                    >
                      <option value="Placed">Placed</option>
                      <option value="Processed">Processed</option>
                      <option value="Shipped">Shipped</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Canceled">Canceled</option>
                    </select>
                  </td>

                  {/* Date */}
                  <td className="px-5 py-3">
                    {new Date(order.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ===== Pagination ===== */}
      <div className="flex justify-end mt-4">
        <ReactPaginate
          pageCount={totalPages}
          onPageChange={(e) => setCurrentPage(e.selected + 1)}
          containerClassName="flex gap-2"
          pageClassName="px-3 py-1 border border-gray-700 rounded text-white"
          activeClassName="bg-indigo-600"
        />
      </div>
    </div>
  );
};

export default Order;
